<template>
  <div>
    <PageAllow controller="BalanceCategories" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherKeyword
                v-model="options.keyword"
                @text="KeyWord = $event"
                :label="$t('capital.select')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click="
                  currentItem = {};
                  editDialog = true;
                "
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("capital.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="balance_categories"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('BalanceCategories', 'edit')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click="
                    currentItem = JSON.parse(JSON.stringify(item));
                    editDialog = true;
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("capital.actions.edit") }}
                </v-btn>
              </template>
              <span>{{ $t("capital.actions.edit") }}</span>
            </v-tooltip>

            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('BalanceCategories', 'delete') &&
                item.actions.delete
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="Del(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("capital.actions.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("capital.actions.delete") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("capital.balanceCategoriesInfo")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("capital.balanceCategories")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('capital.balanceCategoriesName')"
                    rules="required"
                  >
                    <v-text-field
                      required
                      v-model="currentItem.category_name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'category_name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:label>
                        {{ $t("capital.balanceCategoriesName") }}
                        <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{
            $t("$vuetify.abandon")
          }}</v-btn>
          <v-btn color="accent" @click="save()">{{
            $t("$vuetify.submit")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import BalanceCategories from "@/api/balance_categories";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const defaultOptions = {
  keyword: "",
};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    balance_categories: [],
    delDialog: false,
    editDialog: false,
    currentItem: {},
    serverErrors: [],
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.capital"),
        disabled: false,
        href: "/capital",
      },
      {
        text: i18n.t("capital.balanceCategories"),
        disabled: true,
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("capital.Fields.category_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "category_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },
    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {
    this.getBalanceCategoriesFromAPI();
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.KeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getBalanceCategoriesFromAPI() {
      BalanceCategories.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.balance_categories = response.data.balance_categories;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },

    Del(delId) {
      BalanceCategories.del(delId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getBalanceCategoriesFromAPI();
          }
          this.delDialog = false;
        }.bind(this)
      );
    },

    save() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = [];
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            BalanceCategories.save(this.currentItem.id, this.currentItem)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    // this.$emit("save", this.currentItem);
                    this.getBalanceCategoriesFromAPI();
                    this.editDialog = false;
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.editDialog = false;
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    editDialog: {
      handler() {
        if (!this.editDialog) {
          this.$refs.observer.reset();
          this.serverErrors = [];
          this.$store.dispatch("fullscreenLoadingStop");
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getBalanceCategoriesFromAPI();
      },
    },
  },
};
</script>

<style>
</style>